/**
 * Строка из частей через « · » переносится только между частями, а не внутри них.
 *
 * ⚠️ ЗАЧЕМ (кадр 390 на стенде 17.10.2026, техдолг 416). Шапка карточки курса на телефоне — «7 учеников · 2 истёкших
 * · 5 уроков»; на узком экране строка рвалась между «5» и «уроков», и число оставалось висеть в конце строки без
 * слова. Пробелы внутри части становятся неразрывными, разделитель « · » остаётся обычным — перенос встаёт на нём.
 */
export function keepPartsTogether(line: string): string {
  return line
    .split(' · ')
    .map((part) => part.replace(/ /g, '\u00a0'))
    .join(' · ');
}
